export const ISSUES_FOR_GROUPING_REQUEST = "ISSUES_FOR_GROUPING_REQUEST";
export const ISSUES_FOR_GROUPING_SUCCESS = "ISSUES_FOR_GROUPING_SUCCESS";
export const ISSUES_FOR_GROUPING_FAILED = "ISSUES_FOR_GROUPING_FAILED";
